// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Top100Labels_root_1RHHh{padding:24px;max-width:1200px;margin:0 auto}.Top100Labels_header_1EJ7Y{margin-bottom:32px}.Top100Labels_title_mnEVx{font-size:28px;font-weight:600;color:#313a46;margin:0 0 16px 0}.Top100Labels_subtitle_12XYs{font-size:16px}.Top100Labels_required_3ak-r,.Top100Labels_subtitle_12XYs{color:#8391a2;margin:0}.Top100Labels_required_3ak-r{font-size:14px}", ""]);
// Exports
exports.locals = {
	"root": "Top100Labels_root_1RHHh",
	"header": "Top100Labels_header_1EJ7Y",
	"title": "Top100Labels_title_mnEVx",
	"subtitle": "Top100Labels_subtitle_12XYs",
	"required": "Top100Labels_required_3ak-r"
};
module.exports = exports;
